const Browser = {
    getIEVersion() {
        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
            /*
             * sample user-Agent
             * "Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.1; WOW64; Trident/6.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; .NET4.0C; .NET4.0E)"
             */
            // test for MSIE x.x;
            return new Number(RegExp.$1); // capture x.x portion and store as a number
        }
        return -1;
    },
    getChromeVersion() {
        const chrome = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        if (chrome) {
            return parseInt(chrome[2], 10);
        }
    },
    getFirefoxVersion() {
        const firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
        if (firefox) {
            return parseInt(firefox[1]);
        }
    },
    isIE6() {
        if (document.all && !window.opera && !window.XMLHttpRequest) {
            return true;
        }
        return false;
    },
    isIE7() {
        return Browser.getIEVersion() == 7;
    },
    isIE8() {
        return Browser.getIEVersion() == 8;
    },
    isIE9() {
        return Browser.getIEVersion() == 9;
    },
    isIE9Standards() {
        return Browser.isIE9() && !Browser.isQuirksMode();
    },
    isIE10() {
        return Browser.getIEVersion() == 10;
    },
    isIE10Standards() {
        return Browser.isIE10() && !Browser.isQuirksMode();
    },
    isIE11() {
        const matches = navigator.userAgent.match(
            /(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/
        );
        if (matches && matches.length == 3) {
            return matches[2] == 11;
        }
        return false;
    },
    isIE() {
        // this returns false if in IE9 standards, because all our non-IE code WORKS IN IE9 standards!!! IE9 hardly counts as IE anymore!
        // IE10 also doesn't count, quirks mode or not
        return (
            !!document.protocol &&
            !(
                Browser.isIE9Standards() ||
                Browser.isIE10() ||
                Browser.isIE11()
            )
        );
    },
    isQuirksMode() {
        const mode = document.compatMode;
        let m;
        return mode && mode == 'BackCompat';
    },
    isiOS() {
        // Added Window.MSStream // Source: https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
        return /iPad|iPhone|iPod/.test(navigator.platform) && !window.MSStream;
    },
    isAndroid() {
        return /Android/i.test(navigator.userAgent);
    },
    isMacintosh() {
        return /Mac/.test(navigator.platform) && !window.MSStream;
    },
    isChrome() {
        const isChromium = window.chrome;
        const winNav = window.navigator;
        const vendorName = winNav.vendor;
        const isOpera = winNav.userAgent.indexOf('OPR') > -1;
        const isIEedge = winNav.userAgent.indexOf('Edge') > -1;
        const isIOSChrome = winNav.userAgent.match('CriOS');

        // http://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
        return (
            isChromium !== null &&
            isChromium !== undefined &&
            vendorName === 'Google Inc.' &&
            isOpera == false &&
            isIEedge == false
        );
    },
    isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1) {
            if (ua.indexOf('chrome') < 0) {
                return true;
            }
        }
    },
    isFirefox() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('firefox') != -1) {
            if (ua.indexOf('chrome') < 0) {
                return true;
            }
        }
    }
};
export default Browser;
